import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from '@/pages/HomePage';
import ServicesPage from '@/pages/ServicesPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import { Toaster } from '@/components/ui/sonner';
import { SimpleCommentSystem } from '@/components/SimpleCommentSystem';

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/DumpsterRentalV1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <SimpleCommentSystem />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
